import { https } from 'shared/utils/https';
import type { IGetOrderDetailResponse, IGetOrderRequest, IGetOrdersListDTO, IGetOrdersRequest } from './orders.dto';

const orderBaseURL = '/v1/maintenance-orders';

export const ordersData = {
  getOrders: async (params: IGetOrdersRequest): Promise<IGetOrdersListDTO> => {
    const { data } = await https.get<IGetOrdersListDTO>(orderBaseURL, {
      params,
    });

    return data;
  },

  getOderDetail: async ({ orderId }: IGetOrderRequest): Promise<IGetOrderDetailResponse> => {
    const { data } = await https.get<IGetOrderDetailResponse>(`${orderBaseURL}/${orderId}`);

    return data;
  },
};
